import Header from '../components/Header';
import RecurentSurveys from '../components/Surveys';

export function SurveyRecurrentPage() {
  return (
    <div className="mainAppContainer">
      <div className="pageContainer">
        <Header long={true} includeBackButton={true} />
        <RecurentSurveys />;
      </div>
    </div>
  );
}

export default SurveyRecurrentPage;
